<template>
	<vxe-modal v-model.trim="modelEditFlag" title="彩虹糖车辆" width="800" height="600" resize>
		<div class="containerTable">
			<vxe-toolbar id="toolbarId_re4" :custom="{ storage: true }" export :refresh="{ query: findList }">
				<template v-slot:buttons>
					<el-button @click="funcFilter">
						查询
					</el-button>
					<el-button @click="funcChecked">
						获取选中
					</el-button>
				</template>
			</vxe-toolbar>
			<vxe-table ref="xTable" border resizable highlight-hover-row highlight-current-row row-id="id" height="80%"
				:loading="loading" :data="tableData" show-footer :footer-method="footerMethod"
				:sort-config="{ remote: true }" show-overflow align="center" class="mytable-style"
				@sort-change="sortList">
				<vxe-table-column type="checkbox" width="60" fixed="left" />
				<vxe-table-column>
					<vxe-table-column field="licenseNumber" title="车牌号" min-width="130" sortable />
					<template v-slot:header>
						<el-input v-model="listQuery.licenseNumber" placeholder="请输入车牌号" clearable />
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="vehicleLicenseColor" title="车牌颜色" :formatter="formatterCehicleLicenseColor"
						min-width="130" sortable />
					<template v-slot:header>
						<el-select v-model="listQuery.vehicleLicenseColor" placeholder="请选择" clearable>
							<el-option v-for="item in vehicleLicenseColorList" :key="item.code"
				 			:label="item.name" :value="item.code" clearable />
						</el-select>
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="vehicleLicense" title="车辆行驶证档案编号" min-width="200" sortable />
					<template v-slot:header>
						<el-input v-model="listQuery.vehicleLicense" placeholder="请输入车辆行驶证档案编号" clearable />
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="classificationCode" title="车辆分类"
						:formatter="formatterVehicleClassification" min-width="130" sortable />
					<template v-slot:header>
						<el-select v-model="listQuery.classificationCode" placeholder="请选择" clearable>
							<el-option v-for="item in vehicleClassificationList" :key="item.code"
								:label="item.name" :value="item.code" clearable />
						</el-select>
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="vehicleLicenseDueDate" title="车辆行驶证到期日期" min-width="420" sortable />
					<template v-slot:header>
						<el-date-picker v-model="vehicleLicenseDueDateRange" type="daterange" value-format="yyyy-MM-dd"
							:picker-options="optionsPicker" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" @change="value => changeDate(value, 'vehicleLicenseDueDate')" />
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="roadTransportCertificateDate" title="道路运输证到期日期" min-width="420" sortable />
					<template v-slot:header>
						<el-date-picker v-model="roadTransportCertificateDateRange" type="daterange"
							value-format="yyyy-MM-dd" :picker-options="optionsPicker" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期"
							@change="value => changeDate(value, 'roadTransportCertificateDate')" />
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="gmtCreated" title="创建时间" min-width="420" sortable />
					<template v-slot:header>
						<el-date-picker v-model="gmtCreatedRange" type="daterange" value-format="yyyy-MM-dd"
				  	:picker-options="optionsPicker" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" @change="value => changeDate(value, 'gmtCreated')" />
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="owner" title="车主姓名" min-width="130" sortable />
					<template v-slot:header>
						<el-input v-model="listQuery.owner" placeholder="请输入车主姓名" clearable />
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="realOwnerPhone" title="车主电话" min-width="130" sortable />
					<template v-slot:header>
						<el-input v-model="listQuery.realOwnerPhone" placeholder="请输入车主电话" clearable />
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="roadTransportCertificateNumber" title="道路运输证号" min-width="130" sortable />
					<template v-slot:header>
						<el-input v-model="listQuery.roadTransportCertificateNumber" placeholder="请输入车辆道路运输证号"
							clearable />
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="vehicleEnergyType" title="能源类型" :formatter="formatterVehicleEnergyType"
						min-width="130" sortable />
					<template v-slot:header>
						<el-select v-model="listQuery.vehicleEnergyType" placeholder="请选择" clearable>
							<el-option v-for="item in vehicleEnergyTypeList" :key="item.code"
								:label="item.name" :value="item.code" clearable />
						</el-select>
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="totalWeight" title="总质量/挂车车头整备质量(Kg)" min-width="240" sortable />
					<template v-slot:header>
				 	<el-row>
							<el-col :span="11">
								<el-input v-model="listQuery.totalWeightStart" type="number" placeholder="下限"
									clearable />
							</el-col>
							<el-col :span="11" :offset="2">
								<el-input v-model="listQuery.totalWeightEnd" type="number" placeholder="上限" clearable />
							</el-col>
						</el-row>
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="loadWeight" title="核定载质量/准牵引总质量(Kg)" min-width="240" sortable />
					<template v-slot:header>
						<el-row>
							<el-col :span="11">
								<el-input v-model="listQuery.loadWeightStart" type="number" placeholder="下限"
									clearable />
							</el-col>
							<el-col :span="11" :offset="2">
								<el-input v-model="listQuery.loadWeightEnd" type="number" placeholder="上限" clearable />
							</el-col>
						</el-row>
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="isHasTrailer" title="是否挂车" :formatter="formatterHasTrailer" min-width="130"
						sortable />
					<template v-slot:header>
						<el-select v-model="listQuery.isHasTrailer" placeholder="请选择" clearable>
							<el-option v-for="item in isHasTrailers" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
					</template>
				</vxe-table-column>
				<vxe-table-column>
					<vxe-table-column field="trailerNum" title="挂车车牌号" min-width="130" sortable />
					<template v-slot:header>
						<el-input v-model="listQuery.trailerNum" placeholder="请输入挂车车牌号" clearable />
					</template>
				</vxe-table-column>
			</vxe-table>
			<vxe-pager :loading="loading" :current-page.sync="listQuery.pageNum" :page-sizes="Pagingconf"
				:page-size.sync="listQuery.pageSize" :total="listQuery.total"
				:layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
				@page-change="handlePageChange" />
		</div>
	</vxe-modal>
</template>
<script>
	import {
		rainbowVehiclePush
	} from "@/api/driver";
	import {
		getListDict
	} from "@/api/shipment";
	export default {
		name: "CarrierReview",
		data() {
			return {
				modelEditFlag: false,
				gmtCreatedRange: "",
				loginkTarget: 0,
				loading: false,
				tableData: [],
				driverFlag: false,
				listQuery: {
					pageNum: 1,
					pageSize: 20,
					sortField: "",
					sortType: "",
					total: 0,
				},
				Pagingconf: [],
				sumObject: {
					balance: 0
				},
				vehicleLicenseDueDateRange: [],
				roadTransportCertificateDateRange: [],
				vehicleTonnageList: [],
				vehicleClassificationList: [],
				vehicleEnergyTypeList: [],
				locationSourceList: [],
				vehicleLicenseColorList: [],
				isHasTrailers: [{
						label: "否",
						value: 0
					},
					{
						label: "是",
						value: 1
					}
				],
			};
		},
		created() {
			// 获取数据字典： 车型，车长，车宽，车高，吨位，定位来源，车牌颜色
			getListDict({
				types: "vehicleClassification,vehicleLength,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleLicenseColor,vehicleEnergyType"
			}).then(response => {
				this.vehicleClassificationList = response.data.filter(
					item => item.type === "vehicleClassification"
				)[0]["dictList"];
				this.vehicleTonnageList = response.data.filter(
					item => item.type === "vehicleTonnage"
				)[0]["dictList"];
				this.locationSourceList = response.data.filter(
					item => item.type === "locationSource"
				)[0]["dictList"];
				this.vehicleLicenseColorList = response.data.filter(
					item => item.type === "vehicleLicenseColor"
				)[0]["dictList"];
				this.vehicleEnergyTypeList = response.data.filter(
					item => item.type === "vehicleEnergyType"
				)[0]["dictList"];
			});
		},
		methods: {
			show(code) {
				this.listQuery.vehicleCode = code
				this.modelEditFlag = true
				this.findList()
			},
			hide() {
				this.modelEditFlag = false
			},
			funcChecked() {
				let selectRecords = this.$refs.xTable.getCheckboxRecords();
				if (!selectRecords || !selectRecords.length) {
					this.$message({
						message: '请选择需要比对的车辆',
						type: 'warning'
					});
				} else {
					const codes = selectRecords.map(item => item.code).join(',');
					this.$emit('selectedDriver', codes)
				}
			},
			findList() {
				this.loading = true;
				return new Promise(resolve => {
					rainbowVehiclePush(this.listQuery).then(response => {
						this.tableData = response.data.records;
						this.listQuery.total = response.data.total;
						response.data.total > 10000 ? this.Pagingconf = [20, 30, 50, 100, 10000] : this
							.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
						this.sumObject = response.data.sumObject;
						this.loading = false;
						resolve();
					});
				});
			},
			// 查询
			funcFilter() {
				this.listQuery.pageNum = 1;
				this.findList();
			},
			// 排序
			sortList({
				column,
				property,
				order
			}) {
				if (order) {
					this.listQuery.sortField = property;
					this.listQuery.sortType = order;
				} else {
					this.listQuery.sortField = "";
				}
				this.findList();
			},

			// 翻译审核状态
			formatterAuthStatus({
				cellValue
			}) {
				const item = this.authStatusOptions.find(
					item => item.value === cellValue
				);
				return item ? item.label : "";
			},
			// 时间
			changeDate(value, prefix) {
				if (value) {
					this.listQuery[`${prefix}Start`] = value[0] + " 00:00:00";
					this.listQuery[`${prefix}End`] = value[1] + " 23:59:59";
				} else {
					this.listQuery[`${prefix}Start`] = "";
					this.listQuery[`${prefix}End`] = "";
				}
			},
			// 翻译车型
			formatterVehicleClassification({
				cellValue
			}) {
				const item = this.vehicleClassificationList.find(
					item => item.code === cellValue
				);
				return item ? item.name : "";
			},
			// 翻译车牌颜色
			formatterCehicleLicenseColor({
				cellValue
			}) {
				const item = this.vehicleLicenseColorList.find(
					item => item.code === cellValue
				);
				return item ? item.name : "";
			},
			formatterHasTrailer({
				cellValue
			}) {
				const item = this.isHasTrailers.find(item => item.value === cellValue);
				return item ? item.label : "";
			},
			// 翻译能源类型
			formatterVehicleEnergyType({
				cellValue
			}) {
				const item = this.vehicleEnergyTypeList.find(
					item => item.code === cellValue
				);
				return item ? item.name : "";
			},
			// 分页handle
			handlePageChange({
				currentPage,
				pageSize
			}) {
				this.listQuery.pageNum = currentPage;
				this.listQuery.pageSize = pageSize;
				this.findList();
			},
			// 设置底部合计
			footerMethod({
				columns,
				data
			}) {
				return [
					columns.map((column, columnIndex) => {
						if (columnIndex === 0) {
							return "合计";
						}
						if (column.property === "balance") {
							return this.$XEUtils.sum(data, column.property);
						}
						return "-";
					})
				];
			},
		}
	};
</script>
<style scoped>
	.mytable-style .vxe-body--column.col-red {
		background-color: red;
		color: #fff;
	}
